"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StarsQuestion = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactStreamlineIcons = require("@cimpress-technology/react-streamline-icons");

var _reactComponents = require("@cimpress/react-components");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const StarsQuestion = props => {
  const {
    value,
    disabled,
    onChange
  } = props;
  const [starsMouseHighlight, setStarsMouseHighlight] = React.useState(0);
  const stars = [1, 2, 3, 4, 5].map(i => /*#__PURE__*/React.createElement("a", {
    key: i,
    className: 'ctrf-stars-item',
    onMouseEnter: () => {
      if (!disabled) {
        setStarsMouseHighlight(i);
      }
    }
  }, /*#__PURE__*/React.createElement(_reactStreamlineIcons.IconRatingStar, {
    size: 'lg',
    color: disabled ? _reactComponents.colors.alloy : undefined,
    weight: starsMouseHighlight === 0 && value && parseInt(value) >= i || starsMouseHighlight >= i ? 'fill' : 'regular',
    onClick: disabled ? null : () => onChange(i)
  })));
  return /*#__PURE__*/React.createElement("div", {
    className: "ctrf-stars-container",
    onMouseLeave: () => {
      if (!disabled) {
        setStarsMouseHighlight(0);
      }
    }
  }, stars);
};

exports.StarsQuestion = StarsQuestion;